import React from 'react';
import {
  Box,
  Container,
  Grid,
  GridItem,
  VStack,
  Text,
  Portal,
  useColorModeValue,
  Image,
} from '@chakra-ui/react';
import { getServiceLinks } from '../../constants/navigationData';
import { useScrollToClose } from './hooks/useScrollToClose';
import { useNavigate, useLocation } from 'react-router-dom';




const ServiceMegaMenu = ({ isOpen, onClose, onMouseEnter, onMouseLeave }) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.100', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const navigate = useNavigate();
  const location = useLocation();

  // Get static services data directly
  const services = getServiceLinks();

  // Use scroll-to-close hook
  useScrollToClose(isOpen, onClose);

  return (
    <Portal>
      <Box
        position="fixed"
        top="60px"
        left="0"
        right="0"
        bg={bgColor}
        boxShadow="xl"
        border="1px"
        borderColor={borderColor}
        zIndex="dropdown"
        display={isOpen ? 'block' : 'none'}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        data-mega-menu
      >
        <Container maxW="8xl" py={8}>
          <Grid 
            templateColumns={{
              base: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
              xl: "repeat(5, 1fr)",
            }} 
            gap={6}
          >
            {services && services.length > 0 ? (
              services.slice(0, 10).map((service, index) => {
                const isCurrentService = location.pathname === service.href;
                return (
                  <GridItem key={service.id || index}>
                    <VStack
                      align="start"
                      spacing={4}
                      p={5}
                      borderRadius="lg"
                      bg={isCurrentService ? 'blue.50' : 'transparent'}
                      border={isCurrentService ? '2px solid' : '1px solid transparent'}
                      borderColor={isCurrentService ? '#000B8C' : 'transparent'}
                      _hover={{ bg: isCurrentService ? 'blue.100' : 'gray.50', cursor: 'pointer' }}
                      transition="all 0.2s"
                      onClick={() => {
                        navigate(service.href);
                        onClose();
                      }}
                    >
                      {/* Service Icon */}
                      <Image
                        src={service.image}
                        alt={service.title}
                        boxSize="40px"
                        objectFit="contain"
                        fallbackSrc="/png/our-service.png"
                      />
                      
                      <Text 
                        fontWeight={isCurrentService ? "bold" : "bold"} 
                        fontSize="md" 
                        color={isCurrentService ? '#000B8C' : textColor}
                      >
                        {service.title}
                      </Text>
                      <Text fontSize="sm" color="gray.500" lineHeight="short" noOfLines={3}>
                        {service.description}
                      </Text>
                    </VStack>
                  </GridItem>
                );
              })
            ) : (
              <Text color="gray.500" textAlign="center">No services available</Text>
            )}
          </Grid>
        </Container>
      </Box>
    </Portal>
  );
};

export default ServiceMegaMenu;
